module.exports = __webpack_public_path__ + "static/media/development2.3d75a5c6.jpg";